// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as IndexedDB$OrcaPaymentPage from "../libraries/IndexedDB.bs.js";

function logApi(eventName, statusCodeOpt, dataOpt, apiLogType, urlOpt, paymentMethodOpt, resultOpt, optLogger, logTypeOpt, logCategoryOpt, isPaymentSessionOpt) {
  var statusCode = statusCodeOpt !== undefined ? statusCodeOpt : 0;
  var data = dataOpt !== undefined ? dataOpt : ({});
  var url = urlOpt !== undefined ? urlOpt : "";
  var paymentMethod = paymentMethodOpt !== undefined ? paymentMethodOpt : "";
  var result = resultOpt !== undefined ? resultOpt : ({});
  var logType = logTypeOpt !== undefined ? logTypeOpt : "INFO";
  var logCategory = logCategoryOpt !== undefined ? logCategoryOpt : "API";
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var match;
  switch (apiLogType) {
    case "Request" :
        match = [
          [[
              "url",
              url
            ]],
          []
        ];
        break;
    case "Response" :
        match = [
          [
            [
              "url",
              url
            ],
            [
              "statusCode",
              statusCode
            ]
          ],
          [[
              "response",
              data
            ]]
        ];
        break;
    case "NoResponse" :
        match = [
          [
            [
              "url",
              url
            ],
            [
              "statusCode",
              504
            ],
            [
              "response",
              data
            ]
          ],
          [[
              "response",
              data
            ]]
        ];
        break;
    case "Method" :
        match = [
          [[
              "method",
              paymentMethod
            ]],
          [[
              "result",
              result
            ]]
        ];
        break;
    case "Err" :
        match = [
          [
            [
              "url",
              url
            ],
            [
              "statusCode",
              statusCode
            ],
            [
              "response",
              data
            ]
          ],
          [[
              "response",
              data
            ]]
        ];
        break;
    
  }
  if (optLogger !== undefined) {
    return optLogger.setLogApi({
                TAG: "ArrayType",
                _0: match[0]
              }, eventName, undefined, logType, logCategory, undefined, apiLogType, isPaymentSession);
  }
  
}

function logInputChangeInfo(text, logger) {
  logger.setLogInfo(text, "INPUT_FIELD_CHANGED", undefined, undefined, undefined, undefined, undefined);
}

function handleLogging(optLogger, value, eventName, paymentMethod, logTypeOpt) {
  var logType = logTypeOpt !== undefined ? logTypeOpt : "INFO";
  if (optLogger !== undefined) {
    return optLogger.setLogInfo(value, eventName, undefined, undefined, logType, undefined, paymentMethod);
  }
  
}

function eventNameToStrMapper(eventName) {
  return eventName;
}

function getPaymentId(clientSecret) {
  return Core__Option.getOr(clientSecret.split("_secret_")[0], "");
}

function convertToScreamingSnakeCase(text) {
  return text.trim().replace(/ /g, "_").toUpperCase();
}

function toSnakeCaseWithSeparator(str, separator) {
  return str.replace(/[A-Z]/g, (function (letter, param, param$1) {
                return separator + letter.toLowerCase();
              }));
}

function defaultLoggerConfig_setLogInfo(param, param$1, param$2, param$3, param$4, param$5, param$6) {
  
}

function defaultLoggerConfig_setLogError(param, param$1, param$2, param$3, param$4, param$5, param$6) {
  
}

function defaultLoggerConfig_setLogApi(param, param$1, param$2, param$3, param$4, param$5, param$6, param$7) {
  
}

function defaultLoggerConfig_setLogInitiated() {
  
}

function defaultLoggerConfig_setConfirmPaymentValue(param) {
  return {};
}

function defaultLoggerConfig_sendLogs() {
  
}

function defaultLoggerConfig_setSessionId(_x) {
  
}

function defaultLoggerConfig_setClientSecret(_x) {
  
}

function defaultLoggerConfig_setMerchantId(_x) {
  
}

function defaultLoggerConfig_setMetadata(_x) {
  
}

function defaultLoggerConfig_setSource(_x) {
  
}

var defaultLoggerConfig = {
  setLogInfo: defaultLoggerConfig_setLogInfo,
  setLogError: defaultLoggerConfig_setLogError,
  setLogApi: defaultLoggerConfig_setLogApi,
  setLogInitiated: defaultLoggerConfig_setLogInitiated,
  setConfirmPaymentValue: defaultLoggerConfig_setConfirmPaymentValue,
  sendLogs: defaultLoggerConfig_sendLogs,
  setSessionId: defaultLoggerConfig_setSessionId,
  setClientSecret: defaultLoggerConfig_setClientSecret,
  setMerchantId: defaultLoggerConfig_setMerchantId,
  setMetadata: defaultLoggerConfig_setMetadata,
  setSource: defaultLoggerConfig_setSource
};

function saveLogsToIndexedDB(logs) {
  return new Promise((function (resolve, reject) {
                var request = IndexedDB$OrcaPaymentPage.openDBAndGetRequest("HyperLogger", "logs");
                request.onsuccess = (function (param) {
                    var db = request.result;
                    if (logs.length > 0) {
                      var transaction = db.transaction(["logs"], "readwrite");
                      var store = transaction.objectStore("logs");
                      transaction.oncomplete = (function (param) {
                          db.close();
                          resolve();
                        });
                      transaction.onerror = (function (param) {
                          db.close();
                          reject();
                        });
                      logs.forEach(function (log) {
                            store.put(log);
                          });
                      return ;
                    }
                    db.close();
                    reject();
                  });
                request.onerror = (function (param) {
                    reject();
                  });
              }));
}

function retrieveLogsFromIndexedDB() {
  return new Promise((function (resolve, reject) {
                var request = IndexedDB$OrcaPaymentPage.openDBAndGetRequest("HyperLogger", "logs");
                request.onsuccess = (function (param) {
                    var db = request.result;
                    var transaction = db.transaction(["logs"], "readonly");
                    var store = transaction.objectStore("logs");
                    var getAllRequest = store.getAll();
                    getAllRequest.onsuccess = (function (param) {
                        var result = getAllRequest.result;
                        db.close();
                        resolve(result);
                      });
                    getAllRequest.onerror = (function (param) {
                        db.close();
                        reject([]);
                      });
                  });
                request.onerror = (function (param) {
                    reject([]);
                  });
              }));
}

function clearLogsFromIndexedDB() {
  return new Promise((function (resolve, reject) {
                var request = IndexedDB$OrcaPaymentPage.openDBAndGetRequest("HyperLogger", "logs");
                request.onsuccess = (function (param) {
                    var db = request.result;
                    var transaction = db.transaction(["logs"], "readwrite");
                    var store = transaction.objectStore("logs");
                    var clearRequest = store.clear();
                    clearRequest.onsuccess = (function (param) {
                        db.close();
                        resolve();
                      });
                    clearRequest.onerror = (function (param) {
                        db.close();
                        reject();
                      });
                  });
                request.onerror = (function (param) {
                    reject();
                  });
              }));
}

function apiEventInitMapper(eventName) {
  switch (eventName) {
    case "RETRIEVE_CALL" :
        return "RETRIEVE_CALL_INIT";
    case "AUTHENTICATION_CALL" :
        return "AUTHENTICATION_CALL_INIT";
    case "CONFIRM_CALL" :
        return "CONFIRM_CALL_INIT";
    case "CONFIRM_PAYOUT_CALL" :
        return "CONFIRM_PAYOUT_CALL_INIT";
    case "SESSIONS_CALL" :
        return "SESSIONS_CALL_INIT";
    case "PAYMENT_METHODS_CALL" :
        return "PAYMENT_METHODS_CALL_INIT";
    case "CUSTOMER_PAYMENT_METHODS_CALL" :
        return "CUSTOMER_PAYMENT_METHODS_CALL_INIT";
    case "CREATE_CUSTOMER_PAYMENT_METHODS_CALL" :
        return "CREATE_CUSTOMER_PAYMENT_METHODS_CALL_INIT";
    case "POLL_STATUS_CALL" :
        return "POLL_STATUS_CALL_INIT";
    case "COMPLETE_AUTHORIZE_CALL" :
        return "COMPLETE_AUTHORIZE_CALL_INIT";
    case "PAYMENT_METHODS_AUTH_EXCHANGE_CALL" :
        return "PAYMENT_METHODS_AUTH_EXCHANGE_CALL_INIT";
    case "PAYMENT_METHODS_AUTH_LINK_CALL" :
        return "PAYMENT_METHODS_AUTH_LINK_CALL_INIT";
    case "POST_SESSION_TOKENS_CALL" :
        return "POST_SESSION_TOKENS_CALL_INIT";
    case "ENABLED_AUTHN_METHODS_TOKEN_CALL" :
        return "ENABLED_AUTHN_METHODS_TOKEN_CALL";
    case "ELIGIBILITY_CHECK_CALL" :
        return "ELIGIBILITY_CHECK_CALL";
    case "AUTHENTICATION_SYNC_CALL" :
        return "AUTHENTICATION_SYNC_CALL";
    case "PAYMENT_METHOD_ELIGIBILITY_CALL" :
        return "PAYMENT_METHOD_ELIGIBILITY_CALL_INIT";
    default:
      return ;
  }
}

export {
  logApi ,
  logInputChangeInfo ,
  handleLogging ,
  eventNameToStrMapper ,
  getPaymentId ,
  convertToScreamingSnakeCase ,
  toSnakeCaseWithSeparator ,
  defaultLoggerConfig ,
  saveLogsToIndexedDB ,
  retrieveLogsFromIndexedDB ,
  clearLogsFromIndexedDB ,
  apiEventInitMapper ,
}
/* No side effect */
